// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3RmeO","message":"_2-N-e"};